import { useState, useEffect } from "react";

// Arbitrum chain IDs: 42161 = mainnet, 421614 = Sepolia testnet
const ARBITRUM_DEFAULTS = {
  mainnet_chain_id: 42161,
  testnet_chain_id: 421614,
  default_chain_id: 421614,
  supported_chain_ids: [42161, 421614],
};

export function useChainConfig(apiBaseUrl) {
  const [chainConfig, setChainConfig] = useState(ARBITRUM_DEFAULTS);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!apiBaseUrl) return;

    const fetchChainConfig = async () => {
      setIsLoading(true);
      setError(null);
      try {
        // Extract base URL without /api/v1/katpack prefix for chain-config
        const baseUrl = apiBaseUrl.replace(/\/api\/v1\/katpack$/, "");
        const response = await fetch(`${baseUrl}/chain-config`);
        if (!response.ok) throw new Error(`Failed to fetch chain config: ${response.statusText}`);
        setChainConfig(await response.json());
      } catch (err) {
        console.warn("Failed to load chain config, using Arbitrum defaults:", err.message);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchChainConfig();
  }, [apiBaseUrl]);

  return { chainConfig, isLoading, error };
}
